import { BorderBox, TextSmall } from '@trmediaab/zebra';

import type { ErrorWithMessage } from '../../types/ErrorWithMessage';

interface ErrorMessageProps {
  error: ErrorWithMessage;
  variant?: 'default' | 'input';
}

const ErrorMessage = ({ error, variant }: ErrorMessageProps) =>
  variant === 'input' && error.status != null && error.status < 500 ? (
    <TextSmall display="block" color="state.error">
      {typeof error === 'object'
        ? error.message || 'Ett okänt fel inträffade'
        : error}
    </TextSmall>
  ) : (
    <BorderBox
      border="1"
      borderColor="state.error"
      color="state.error"
      pt="2"
      pb="1"
      px="3"
    >
      <TextSmall display="block" fontWeight="bold">
        Ett fel inträffade!
      </TextSmall>
      <TextSmall display="block">{error.message}</TextSmall>
    </BorderBox>
  );

export default ErrorMessage;
